var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25003 16.5V17.1875C8.25003 17.9168 8.53976 18.6163 9.05549 19.132C9.57121 19.6478 10.2707 19.9375 11 19.9375C11.7294 19.9375 12.4289 19.6478 12.9446 19.132C13.4603 18.6163 13.75 17.9168 13.75 17.1875V16.5M3.62316 15.1005C4.72659 13.75 5.50562 13.0625 5.50562 9.33926C5.50562 5.92969 7.24671 4.71496 8.67972 4.125C8.87007 4.0468 9.04925 3.86719 9.10726 3.67168C9.35863 2.81617 10.0633 2.0625 11 2.0625C11.9368 2.0625 12.6419 2.8166 12.8907 3.67254C12.9487 3.8702 13.1278 4.0468 13.3182 4.125C14.7529 4.71582 16.4923 5.92625 16.4923 9.33926C16.4944 13.0625 17.2735 13.75 18.3769 15.1005C18.8341 15.66 18.4336 16.5 17.634 16.5H4.36179C3.56644 16.5 3.16855 15.6574 3.62316 15.1005Z",
    stroke: "#DA3E3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.96128da72a7831e4a4c6ebbab893ddcd.svg";
export { ForwardRef as ReactComponent };